import { JsonDecoder } from "ts.data.json";
import {
  type Access,
  AccessLevel,
  type AccessSubject,
  type User,
  type UserNames,
  type UserRef,
} from "$apis/parkito/index.ts";

export const accessLevelDecoder = JsonDecoder.enumeration<AccessLevel>(
  AccessLevel,
  "AccessLevel",
);

export const idDecoder = JsonDecoder.object<{ id: string }>({
  id: JsonDecoder.string,
}, "idObject");

export const accessSubjectDecoder = JsonDecoder.oneOf<AccessSubject>(
  [
    JsonDecoder.isExactly("Global"),
    JsonDecoder.object({ Client: idDecoder }, "AccessSubjectClient"),
    JsonDecoder.object({ Site: idDecoder }, "AccesSubjectSite"),
  ],
  "AccessSubject",
);

export const accessDecoder = JsonDecoder.object<Access>({
  level: accessLevelDecoder,
  subject: accessSubjectDecoder,
}, "AccessDecoder");

export const userNamesDecoder = JsonDecoder.object<UserNames>({
  full: JsonDecoder.string,
  given: JsonDecoder.string,
}, "userNamesDecoder");

export const userRefDecoder = JsonDecoder.object<UserRef>({
  email: JsonDecoder.string,
  id: JsonDecoder.string,
}, "userRefDecoder");

export const userDecoder = JsonDecoder.object<User>({
  accesses: JsonDecoder.array(accessDecoder, "accessesDecoder"),
  names: JsonDecoder.optional(userNamesDecoder),
  invited_by: JsonDecoder.optional(userRefDecoder),
  email: JsonDecoder.optional(JsonDecoder.string),
  id: JsonDecoder.string,
}, "userDecoder");
